import { useEffect } from 'react';
import { useSiteContent } from '../context/SiteContentContext';

// Page titles in all three languages
const pageTitles = {
  home: {
    en: 'Tetralog Ltd. | International Transport & Logistics',
    bg: 'Тетралог ЕООД | Международен Транспорт и Логистика',
    de: 'Tetralog EOOD | Internationaler Transport & Logistik'
  },
  about: {
    en: 'About Us | Tetralog Ltd.',
    bg: 'За Нас | Тетралог ЕООД',
    de: 'Über uns | Tetralog EOOD'
  },
  services: {
    en: 'Our Services | Tetralog Ltd.',
    bg: 'Нашите Услуги | Тетралог ЕООД',
    de: 'Unsere Dienstleistungen | Tetralog EOOD'
  },
  fleet: {
    en: 'Our Fleet | Tetralog Ltd.',
    bg: 'Нашият Флот | Тетралог ЕООД',
    de: 'Unsere Flotte | Tetralog EOOD'
  },
  destinations: {
    en: 'Destinations | Tetralog Ltd.',
    bg: 'Дестинации | Тетралог ЕООД',
    de: 'Transportziele | Tetralog EOOD'
  },
  whyChooseUs: {
    en: 'Why Choose Us | Tetralog Ltd.',
    bg: 'Защо Да Изберете Нас | Тетралог ЕООД',
    de: 'Warum uns wählen | Tetralog EOOD'
  },
  faq: {
    en: 'FAQ | Tetralog Ltd.',
    bg: 'Често Задавани Въпроси | Тетралог ЕООД',
    de: 'FAQ | Tetralog EOOD'
  },
  contact: {
    en: 'Contact Us | Tetralog Ltd.',
    bg: 'Контакти | Тетралог ЕООД',
    de: 'Kontakt | Tetralog EOOD'
  },
  careers: {
    en: 'Careers | Tetralog Ltd.',
    bg: 'Кариери | Тетралог ЕООД',
    de: 'Karriere | Tetralog EOOD'
  },
  news: {
    en: 'News | Tetralog Ltd.',
    bg: 'Новини | Тетралог ЕООД',
    de: 'Nachrichten | Tetralog EOOD'
  },
  admin: {
    en: 'Admin Panel | Tetralog Ltd.',
    bg: 'Администрация | Тетралог ЕООД',
    de: 'Admin Panel | Tetralog EOOD'
  },
  'privacy-policy': {
    en: 'Privacy Policy | Tetralog Ltd.',
    bg: 'Политика за Поверителност | Тетралог ЕООД',
    de: 'Datenschutzrichtlinie | Tetralog EOOD'
  },
  'terms-of-service': {
    en: 'Terms of Service | Tetralog Ltd.',
    bg: 'Общи Условия | Тетралог ЕООД',
    de: 'Nutzungsbedingungen | Tetralog EOOD'
  },
  'cookie-policy': {
    en: 'Cookie Policy | Tetralog Ltd.',
    bg: 'Политика за Бисквитки | Тетралог ЕООД',
    de: 'Cookie-Richtlinie | Tetralog EOOD'
  },
  'ldm-calculator': {
    en: 'Cargo Space Calculator | Tetralog Ltd.',
    bg: 'Калкулатор Товарно Пространство | Тетралог ЕООД',
    de: 'Frachtraumrechner | Tetralog EOOD'
  }
};

/**
 * Custom hook to set page title based on language
 * @param {string} pageKey - Key from pageTitles object
 * @param {string} customTitle - Optional custom title to override default
 */
export function usePageTitle(pageKey, customTitle = null) {
  const { language } = useSiteContent();

  useEffect(() => {
    if (customTitle) {
      document.title = customTitle;
    } else if (pageTitles[pageKey]) {
      // Get title for current language, fallback to English
      document.title = pageTitles[pageKey][language] || pageTitles[pageKey].en;
    }
  }, [pageKey, customTitle, language]);
}

export default usePageTitle;
